import UserActionError from '@/interfaces/errors/userAction';
const PREFIX = 'components: Spreadsheet: errors:';
export const CODES = {
  workbookGen: `${PREFIX}WorkbookGen`,
  unknownUniver: `${PREFIX}unknownUniver`,
  univerSelection: `${PREFIX}univerSelection`,
  uneditableWorkbook: `${PREFIX}uneditableWorkbook`
};
const USER_MESSAGES = {
  workbookGen: 'Failed to read data, please try again, upload new data, or contact support',
  unknownUniver: 'Unexpected editor error, you may experience issues',
  univerSelection: 'Spreadsheet selection failed, please try again',
  uneditableWorkbook: 'Workbook is not currently editable'
};
export const createWorkbookGenerateError = (prefix, err) => {
  const actionErr = new UserActionError(`${prefix} failed to convert workbook: ${err}`);
  actionErr.userMessage = USER_MESSAGES.workbookGen;
  actionErr.code = CODES.workbookGen;
  return actionErr;
};
export const createUnknownUniverError = (prefix, err) => {
  const actionErr = new UserActionError(`${prefix} unknown univer error: ${err}`);
  actionErr.userMessage = USER_MESSAGES.unknownUniver;
  actionErr.code = CODES.unknownUniver;
  return actionErr;
};
export const createSelectionError = (prefix, err) => {
  const actionErr = new UserActionError(`${prefix} univer selection error: ${err}`);
  actionErr.userMessage = USER_MESSAGES.univerSelection;
  actionErr.code = CODES.univerSelection;
  return actionErr;
};
export const createUndoWarning = prefix => {
  const actionErr = new UserActionError(`${prefix} user editing uneditable workbook`);
  actionErr.userMessage = USER_MESSAGES.uneditableWorkbook;
  actionErr.code = CODES.uneditableWorkbook;
  return actionErr;
};
export default {
  createWorkbookGenerateError,
  createUnknownUniverError,
  createSelectionError,
  createUndoWarning
};